import Filters from "@wwdev/product/filters";

class Product {
	constructor() {
		if ($('[package="cms-product"]').length < 1) {
			return;
		}
		this.filters = new Filters();
		this.filters.stickyOffsetHeight = parseFloat($('html').css('--header-height').replace('px', '')) + 10;
	}
}

export default new Product();